module.exports = __webpack_public_path__ + "assets/img/shop.4e752547.png";